/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlterarMatriculaAliases {
  CARD_0 = 'card-0',
  FETCH_ATUAL = 'fetch-atual',
  FIELD_1 = 'field-1',
  FIELD_ATUAL = 'field-atual',
  FIELD_TOAST = 'field-toast',
  FORM_ALTERAR_MATRICULA = 'form-alterar-matricula',
  INPUT_0 = 'input-0',
  MAPPER_1 = 'mapper-1',
  PANEL_0 = 'panel-0',
  PANEL_ALTERAR_MATRICULA = 'panel-alterar-matricula',
  TEXT_0 = 'text-0',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AlterarMatriculaAliases };
